export default "__VITE_ASSET__Ci0HdOjn__"